// extracted by mini-css-extract-plugin
export default {"modalCont":"PaymentInfoModal_modalCont__8NL5C","close":"PaymentInfoModal_close__7KWOe","titles":"PaymentInfoModal_titles__sVbla","signUpBtn":"PaymentInfoModal_signUpBtn__kvQaG"};